export default {
  allowVideo: false,
  allowSocial: false,
  allowAlignment: true,
  allowButton: false,
  allowCode: false,
  allowEmoji: true
};